export default __webpack_public_path__ + "static/media/Spring21_08.4ef5460f.png";